/**
 * @param {string} name
 * @param {Object} data
 * @return {string}
 */
export function template(name, data) {
    let html = document.querySelector(`#${name}`).innerHTML;

    let regex = /{{\s*(\w*)\s*}}/gi;
    let currentMatch;
    let variables = [];

    // Find variables
    while ((currentMatch = regex.exec(html)) !== null) {
        variables.push(currentMatch[1]);
    }

    // Replace variables with data
    variables.filter((match, index, matches) => matches.indexOf(match) === index)
        .forEach(variable => html = html.replace(RegExp(`{{\\s*${variable}\\s*}}`, 'gi'), data[variable]));

    return html;
}